module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d3/btn_2_pc_9440b97a192bc2c8494697e56718376a.png";